module.exports = __webpack_public_path__ + "img/gpu_cover_b.06328a12.png";